module.exports = __webpack_public_path__ + "images/img-3lF3NR2.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/en/5.png
// module id = 2325
// module chunks = 0